class PredictiveSearch extends SearchForm { 
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances =
      document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.defaultSearch = this.querySelector(".default--search");
    this.demoSearch = this.querySelector(".wbsclose");
    this.searchActiveClass = this.dataset.searchActiveClass;
    this.setupEventListeners();
    this.initResize();
  }

  initResize(){
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.resize();
        }
        });
    });
    this.resize();
    const targetElement = this.getElementsByClassName("wbsrightpart")[0];
    if(targetElement) observer.observe(targetElement);
    window.onresize = this.resize;
  }
  resize() {
    if(document.getElementsByClassName("wbsrightpart") && document.getElementsByClassName("wbsrightpart").length > 0){
      Array.from(document.getElementsByClassName("wbsrightpart")).forEach((ele, idx)=>{
        var colHeight = ele.getBoundingClientRect().height;
        if(document.getElementsByClassName("seachbar-left") && document.getElementsByClassName("seachbar-left").length > idx && colHeight>0) 
          document.getElementsByClassName("seachbar-left")[idx].style.maxHeight = colHeight+"px";
      });
      
    }
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this)); 
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.querySelector(".wbsclose").addEventListener('click', this.onClick.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() { 
    super.onChange();
    const newSearchTerm = this.getQuery();
    
    if (!this.defaultSearch.classList.contains('hidden'))
      this.defaultSearch.classList.add("hidden"); 
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;
    if (!this.searchTerm.length) {
      this.defaultSearch.classList.remove("hidden"); //for predictive search
      this.hiddenClassActivity(true);
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) {
      this.defaultSearch.classList.remove("hidden"); // for predictive search
      this.demoSearch.classList.remove("hidden");
      this.hiddenClassActivity(true);
      return;
     }
    

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.hiddenClassActivity(true);
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.defaultSearch.classList.add("hidden");
        this.demoSearch.classList.add("hidden");
        this.hiddenClassActivity(false);
        this.close();
      }
    }, 100 )
  }

  // onFocusOut(event) {
  //   const isChild = event.currentTarget ? event.currentTarget.contains(event.relatedTarget) : false;
  //   const isParent = event.relatedTarget ? event.relatedTarget.contains(event.currentTarget) : false;
  //   console.log('parent: ' + isParent + ', child: ' + isChild);
  //     if (!isChild && !isParent) {
  //       this.defaultSearch.classList.add("hidden");
  //       this.demoSearch.classList.add("hidden");
  //       this.close();
  //     }
  //     else{
  //       this.input.focus();
  //     }
  // }

  onClick() {
    setTimeout(() => {
        this.defaultSearch.classList.add("hidden");
        this.demoSearch.classList.add("hidden");
        this.hiddenClassActivity(false);
        this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&section_id=predictive-search`,
      { signal: this.abortController.signal }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.hiddenClassActivity(false);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.hiddenClassActivity(false);
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.hiddenClassActivity(true);
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
  }

  hiddenClassActivity(isAddOpration = false){
    if(!this.searchActiveClass) return;
    if(!document.body.classList.contains(this.searchActiveClass) && isAddOpration){
        document.body.classList.add(this.searchActiveClass)
    }else if(document.body.classList.contains(this.searchActiveClass) && !isAddOpration){
        document.body.classList.remove(this.searchActiveClass)
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);

/* CM SEARCH 2026-10-12 (Claude): replaces getSearchResults above. Products no longer share 10 spots with the word suggestions (resources[limit_scope]=each), and the product list comes from the full search through sections/cm-search-products.liquid: the main product before its accessories, and a helpful panel when nothing matches. If that request fails, Shopify's own predictive products show as before. Rollback: delete this block. */
PredictiveSearch.prototype.getSearchResults = function (searchTerm) {
  const queryKey = searchTerm.replace(' ', '-').toLowerCase();
  this.setLiveRegionLoadingState();

  if (this.cachedResults[queryKey]) {
    this.renderSearchResults(this.cachedResults[queryKey]);
    return;
  }

  const encodedTerm = encodeURIComponent(searchTerm);
  const signal = this.abortController.signal;
  const searchUrl = routes.predictive_search_url.replace('/suggest', '');
  const productsRequest = fetch(searchUrl + '?q=' + encodedTerm + '&type=product&options%5Bprefix%5D=last&section_id=cm-search-products', { signal: signal })
    .then((response) => (response.ok ? response.text() : ''))
    .catch((error) => {
      if (error && error.code === 20) throw error;
      return '';
    });
  productsRequest.catch(() => {});

  fetch(routes.predictive_search_url + '?q=' + encodedTerm + '&resources%5Btype%5D=product,query,collection,page&resources%5Blimit%5D=5&resources%5Blimit_scope%5D=each&section_id=predictive-search', { signal: signal })
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.hiddenClassActivity(false);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => productsRequest.then((productsText) => [text, productsText]))
    .then(([text, productsText]) => {
      const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
      const cmProducts = productsText ? new DOMParser().parseFromString(productsText, 'text/html').querySelector('.cm-ps-products') : null;
      const rightColumn = section.querySelector('.searchbar-right');
      if (cmProducts && rightColumn) {
        const oldProducts = rightColumn.querySelector('.pseach-prod');
        if (oldProducts) oldProducts.remove();
        rightColumn.prepend(cmProducts);
        const liveRegion = section.querySelector('[data-predictive-search-live-region-count-value]');
        const liveText = cmProducts.getAttribute('data-cm-live');
        if (liveRegion && liveText) liveRegion.textContent = liveText;
      }
      const resultsMarkup = section.innerHTML;
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      this.renderSearchResults(resultsMarkup);
    })
    .catch((error) => {
      if (error && error.code === 20) return;
      this.hiddenClassActivity(false);
      this.close();
      throw error;
    });
};

/* CM SEARCH WORDS 2026-10-24 (Claude). Replaces the CM SEARCH getSearchResults above (same code plus two changes).
   Ro approved "site search understands French words, part numbers and questions like return policy or financing".
   1. cmSearchWords(term): French words, Drive model numbers and common misspellings are searched as the English words
      the catalogue uses ("quadriporteur" searches "mobility scooter", "fauteuil auto-souleveur" searches "lift chair",
      "rtl12027ra" searches "raised toilet seat"). Used for the dropdown products and when a search is sent (Enter, the
      search button, See All), so the results page shows the same products. A search with no word from the list is sent
      exactly as typed. Word list: CM_SEARCH_WORDS (plain form: lower case, no accents, punctuation as spaces; phrases
      before single words). A new word must not be a word in a product title (Expedition is a Drive chair, not shipping).
      French filler words are dropped and the product word goes first, as English puts it ("batterie pour
      quadriporteur" searches "mobility scooter battery", which lists batteries first).
   2. cmSearchQuestionOnly: a question with an answer link (snippets/cm-search-help.liquid, kind i: returns, shipping,
      payment, warranty, contact) and no product whose title holds one of its words shows only the answer in the
      dropdown, not unrelated products.
   Rollback: delete this block; the Oct 12 getSearchResults above takes over again. */
var CM_SEARCH_WORDS = [
  ['rampe pour quadriporteur', 'scooter ramp'], ['rampe pour quatriporteur', 'scooter ramp'], ['rampe pour triporteur', 'scooter ramp'],
  ['rampe pourquatriporteur', 'scooter ramp'], ['rampe pourquadriporteur', 'scooter ramp'], ['rampe pour scooter', 'scooter ramp'],
  ['rampe pour fauteuil roulant', 'wheelchair ramp'], ['rampe pour fauteuil', 'wheelchair ramp'], ['rampe d acces', 'ramp'],
  ['fauteuil roulant electrique', 'power wheelchair'], ['fauteuil roulant motorise', 'power wheelchair'],
  ['chaise roulante electrique', 'power wheelchair'], ['fauteuil electrique', 'power wheelchair'], ['fauteuil motorise', 'power wheelchair'],
  ['fauteuil roulant de transport', 'transport chair'], ['fauteuil de transport', 'transport chair'], ['chaise de transport', 'transport chair'],
  ['fauteuil roulant', 'wheelchair'], ['chaise roulante', 'wheelchair'],
  ['fauteuil auto souleveur', 'lift chair'], ['fauteuil autosouleveur', 'lift chair'], ['fauteuil souleveur', 'lift chair'],
  ['fauteuil releveur', 'lift chair'], ['fauteuil elevateur', 'lift chair'], ['fauteuil inclinable', 'lift chair'], ['auto souleveur', 'lift chair'],
  ['siege de toilette sureleve', 'raised toilet seat'], ['siege de toilette', 'raised toilet seat'], ['siege sureleve', 'raised toilet seat'],
  ['rehausse de toilette', 'raised toilet seat'], ['rehausseur de toilette', 'raised toilet seat'], ['cadre de toilette', 'toilet safety frame'],
  ['chaise d aisance', 'commode'], ['chaise percee', 'commode'],
  ['banc de transfert', 'transfer bench'], ['banc de bain', 'bath bench'], ['banc de douche', 'shower bench'],
  ['chaise de bain', 'bath chair'], ['siege de bain', 'bath chair'], ['chaise de douche', 'shower chair'], ['siege de douche', 'shower chair'],
  ['barre d appui', 'grab bar'], ['barre de soutien', 'grab bar'], ['barre de bain', 'grab bar'],
  ['lit electrique', 'adjustable bed'], ['lit ajustable', 'adjustable bed'], ['lit reglable', 'adjustable bed'],
  ['lit d hopital', 'hospital bed'], ['lit medicalise', 'hospital bed'], ['lit medical', 'hospital bed'],
  ['canne quadripode', 'quad cane'], ['canne a quatre pattes', 'quad cane'], ['baton de marche', 'cane'],
  ['poussette adulte', 'transport chair'], ['pousette adulte', 'transport chair'], ['porte gobelet', 'cup holder'], ['porte canne', 'cane holder'], ['porte bouteille', 'bottle holder'],
  ['appui tete', 'headrest'], ['repose pieds', 'footrest'], ['repose pied', 'footrest'],
  ['pieces de rechange', 'parts'], ['piece de rechange', 'parts'], ['tout terrain', 'all terrain'], ['pas cher', 'cheap'],
  ['politique de retour', 'return policy'], ['politique de remboursement', 'refund policy'], ['frais de livraison', 'shipping'],
  ['suivi de commande', 'track my order'], ['heures d ouverture', 'hours'], ['code promo', 'promo code'], ['guide d achat', 'buying guide'],
  ['virement interac', 'interac etransfer'], ['paiement mensuel', 'pay monthly'], ['paiements mensuels', 'pay monthly'],
  ['nous joindre', 'contact'], ['service a la clientele', 'customer service'],
  ['atc 17', 'transport chair'], ['atc 19', 'transport chair'], ['rtl 12027', 'raised toilet seat'],
  ['deambulateur', 'walker'], ['deambulateurs', 'walker'], ['ambulateur', 'walker'], ['marchette', 'walker'], ['marchettes', 'walker'],
  ['rollateur', 'rollator'], ['rollateurs', 'rollator'], ['rolateur', 'rollator'], ['rollatpr', 'rollator'],
  ['quadriporteur', 'mobility scooter'], ['quadriporteurs', 'mobility scooter'], ['quatriporteur', 'mobility scooter'],
  ['quatriporteurs', 'mobility scooter'], ['triporteur', 'mobility scooter'], ['triporteurs', 'mobility scooter'], ['scootngo', 'mobility scooter'],
  ['autosouleveur', 'lift chair'], ['souleveur', 'lift chair'], ['releveur', 'lift chair'], ['poussette', 'transport chair'], ['pousette', 'transport chair'],
  ['ventouse', 'suction grab bar'], ['ventouses', 'suction grab bar'], ['ventousse', 'suction grab bar'], ['vantouse', 'suction grab bar'],
  ['rampe', 'ramp'], ['rampes', 'ramp'], ['coussin', 'cushion'], ['coussins', 'cushion'], ['matelas', 'mattress'],
  ['canne', 'cane'], ['cannes', 'cane'], ['bequille', 'crutch'], ['bequilles', 'crutches'],
  ['douche', 'shower'], ['baignoire', 'bathtub'], ['toilette', 'toilet'], ['toilettes', 'toilet'],
  ['electrique', 'electric'], ['electriques', 'electric'], ['motorise', 'power'], ['motorisee', 'power'],
  ['leger', 'lightweight'], ['legere', 'lightweight'], ['legers', 'lightweight'], ['legeres', 'lightweight'],
  ['pliable', 'folding'], ['pliables', 'folding'], ['pliant', 'folding'], ['pliante', 'folding'], ['repliable', 'folding'],
  ['portatif', 'portable'], ['portative', 'portable'], ['robuste', 'heavy duty'], ['bariatrique', 'bariatric'],
  ['etroit', 'narrow'], ['etroite', 'narrow'], ['exterieur', 'outdoor'], ['interieur', 'indoor'], ['voyage', 'travel'],
  ['siege', 'seat'], ['roues', 'wheel'], ['roue', 'wheel'],
  ['batterie', 'battery'], ['batteries', 'battery'], ['chargeur', 'charger'], ['panier', 'basket'], ['sac', 'bag'], ['housse', 'cover'],
  ['pneu', 'tire'], ['pneus', 'tires'], ['frein', 'brake'], ['freins', 'brakes'], ['accoudoir', 'armrest'], ['accoudoirs', 'armrests'],
  ['dossier', 'backrest'], ['telecommande', 'remote'], ['manette', 'joystick'], ['auvent', 'canopy'], ['ceinture', 'belt'],
  ['accessoire', 'accessories'], ['accessoires', 'accessories'],
  ['retour', 'return'], ['retours', 'return'], ['remboursement', 'refund'], ['livraison', 'shipping'], ['financement', 'financing'],
  ['paiement', 'payment'], ['paiements', 'payment'], ['virement', 'etransfer'], ['garantie', 'warranty'], ['assurance', 'insurance'],
  ['facture', 'receipt'], ['recu', 'receipt'], ['adresse', 'address'], ['magasin', 'showroom'], ['commande', 'order'],
  ['rabais', 'discount'], ['taxe', 'tax'], ['avis', 'reviews'], ['temoignages', 'testimonials'],
  ['atc17', 'transport chair'], ['atc19', 'transport chair'], ['rtl12027ra', 'raised toilet seat'], ['rtl12027', 'raised toilet seat'],
  ['12027', 'raised toilet seat'], ['vexus', 'nexus'], ['nexsus', 'nexus'], ['trillun', 'trillium'], ['trilium', 'trillium'], ['trillum', 'trillium'],
  ['rebooter', 'robooter'], ['robberter', 'robooter'], ['roboter', 'robooter'], ['robootor', 'robooter'], ['robouter', 'robooter'],
  ['aerolex', 'aerolux'], ['aurolex', 'aerolux'], ['aerolix', 'aerolux'], ['aerolax', 'aerolux'], ['airolux', 'aerolux'], ['areolux', 'aerolux'],
  ['baratric', 'bariatric'], ['bariatic', 'bariatric'], ['break', 'brake'], ['breaks', 'brakes'],
  ['power lift recliners', 'lift chair'], ['power lift recliner', 'lift chair'], ['lift chair recliners', 'lift chair'], ['lift chair recliner', 'lift chair'], ['lift recliners', 'lift chair'], ['lift recliner', 'lift chair'], ['recliner chairs', 'lift chair'], ['recliner chair', 'lift chair'], ['recliners', 'lift chair'], ['recliner', 'lift chair'], ['coffre arriere', 'rear storage'],
  ['fauteuil', 'chair'], ['fauteuils', 'chair'], ['chaise', 'chair'], ['chaises', 'chair']
];

function cmSearchPlain(text) {
  var d = String(text || '').toLowerCase();
  if (d.normalize) d = d.normalize('NFD');
  var o = '';
  for (var i = 0; i < d.length; i++) {
    var c = d.charCodeAt(i);
    if (c >= 768 && c <= 879) continue;
    o += ((c >= 97 && c <= 122) || (c >= 48 && c <= 57)) ? d.charAt(i) : ' ';
  }
  return o.split(' ').filter(function (w) { return w; }).join(' ');
}

function cmSearchWords(term) {
  var raw = String(term || '').trim();
  /* CM 2026-10-31 (audit #10): these whole searches get catalogue words with a better order */
  var cmExact = {'folding scooter': 'folding mobility scooter', 'folding scooters': 'folding mobility scooter', 'adjustable bed': 'harmony adjustable bed', 'adjustable beds': 'harmony adjustable bed', 'commode': 'toilet commode', 'commodes': 'toilet commode'}[cmSearchPlain(raw)];
  if (cmExact) return cmExact;
  var p = ' ' + cmSearchPlain(raw) + ' ';
  var hit = false;
  for (var i = 0; i < CM_SEARCH_WORDS.length; i++) {
    var from = ' ' + CM_SEARCH_WORDS[i][0] + ' ';
    if (p.indexOf(from) > -1) {
      p = p.split(from).join(' ' + CM_SEARCH_WORDS[i][1].split(' ').join('_') + ' ');
      hit = true;
    }
  }
  if (!hit) return raw;
  var drop = ' de du des la le les pour avec a au aux un une et en d l j c n s m t y sur mon ma mes son sa ses qui pas est dans par ou ce cette imc emc ';
  var lead = ' mobility_scooter scooter walker rollator wheelchair power_wheelchair transport_chair lift_chair chair adjustable_bed hospital_bed bed ';
  var words = p.split(' ').filter(function (w) { return w && drop.indexOf(' ' + w + ' ') < 0; });
  var first = words.filter(function (w) { return lead.indexOf(' ' + w + ' ') > -1; });
  var rest = words.filter(function (w) { return lead.indexOf(' ' + w + ' ') < 0; });
  words = first.concat(rest);
  return words.length ? words.join(' ').split('_').join(' ') : raw;
}

function cmSearchQuestionOnly(box, term) {
  if (!box.querySelector('.cm-sh[data-cm-kind="i"]')) return;
  var skip = ' the and for you your how what can are does with from about our any has have get not policy policies transfer ';
  var words = cmSearchPlain(term).split(' ').filter(function (w) { return w.length > 2 && skip.indexOf(' ' + w + ' ') < 0; });
  var titles = box.querySelectorAll('#predictive-search-results-products-list .card__heading a');
  for (var i = 0; i < titles.length; i++) {
    var t = ' ' + cmSearchPlain(titles[i].textContent) + ' ';
    for (var j = 0; j < words.length; j++) {
      if (t.indexOf(' ' + words[j]) > -1) return;
    }
  }
  var heading = box.querySelector('.heading-wrapper');
  var list = box.querySelector('#predictive-search-results-products-list');
  if (heading) heading.remove();
  if (list) list.remove();
  var label = box.querySelector('.cm-sh__link strong');
  if (label) box.setAttribute('data-cm-live', label.textContent.trim());
}

PredictiveSearch.prototype.getSearchResults = function (searchTerm) {
  const queryKey = searchTerm.replace(' ', '-').toLowerCase();
  this.setLiveRegionLoadingState();

  if (this.cachedResults[queryKey]) {
    this.renderSearchResults(this.cachedResults[queryKey]);
    return;
  }

  const productsTerm = cmSearchWords(searchTerm);
  const encodedTerm = encodeURIComponent(searchTerm);
  const signal = this.abortController.signal;
  const searchUrl = routes.predictive_search_url.replace('/suggest', '');
  const productsRequest = fetch(searchUrl + '?q=' + encodeURIComponent(productsTerm) + '&type=product&options%5Bprefix%5D=last&section_id=cm-search-products', { signal: signal })
    .then((response) => (response.ok ? response.text() : ''))
    .catch((error) => {
      if (error && error.code === 20) throw error;
      return '';
    });
  productsRequest.catch(() => {});

  fetch(routes.predictive_search_url + '?q=' + encodedTerm + '&resources%5Btype%5D=product,query,collection,page&resources%5Blimit%5D=5&resources%5Blimit_scope%5D=each&section_id=predictive-search', { signal: signal })
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.hiddenClassActivity(false);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => productsRequest.then((productsText) => [text, productsText]))
    .then(([text, productsText]) => {
      const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
      const cmProducts = productsText ? new DOMParser().parseFromString(productsText, 'text/html').querySelector('.cm-ps-products') : null;
      if (cmProducts) cmSearchQuestionOnly(cmProducts, productsTerm);
      const rightColumn = section.querySelector('.searchbar-right');
      if (cmProducts && rightColumn) {
        const oldProducts = rightColumn.querySelector('.pseach-prod');
        if (oldProducts) oldProducts.remove();
        rightColumn.prepend(cmProducts);
        const liveRegion = section.querySelector('[data-predictive-search-live-region-count-value]');
        const liveText = cmProducts.getAttribute('data-cm-live');
        if (liveRegion && liveText) liveRegion.textContent = liveText;
      }
      const resultsMarkup = section.innerHTML;
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      this.renderSearchResults(resultsMarkup);
    })
    .catch((error) => {
      if (error && error.code === 20) return;
      this.hiddenClassActivity(false);
      this.close();
      throw error;
    });
};

document.addEventListener('submit', function (event) {
  var form = event.target;
  if (!form || !form.querySelector || !form.action) return;
  var input = form.querySelector('input[name="q"]');
  if (!input || !input.value) return;
  var searchPath = (typeof routes !== 'undefined' && routes.predictive_search_url) ? routes.predictive_search_url.replace('/suggest', '') : '/search';
  var path = '';
  try { path = new URL(form.action, window.location.href).pathname; } catch (e) { return; }
  if (path !== searchPath) return;
  var term = cmSearchWords(input.value);
  if (term && term !== input.value.trim()) input.value = term;
}, true);
